import { openModal } from '@core/components/ModalStack';
import { OrgFileShareModalProps } from './OrgFileShareModal';

export async function openOrgFileShareModal(props: OrgFileShareModalProps) {
  const { OrgFileShareModal } = await import('./OrgFileShareModal');

  openModal(OrgFileShareModal, props);
}
